<!-- Floating label variant -->
<div *ngIf="floating && label" class="form-floating selectorini-floating" [class.dropup]="dropUp">
  <div class="form-control selectorini-control d-flex align-items-center justify-content-between"
       [class.disabled]="disabled"
       [class.focused]="isOpen"
       [class.has-value]="hasSelection"
       [class.is-invalid]="invalid"
       (click)="toggleDropdown()">
    <!-- Multiple pills -->
    <div *ngIf="multiple" class="d-flex flex-wrap gap-2 w-100 selectorini-value">
      <span *ngFor="let item of valueArray" class="badge rounded-pill px-2 py-1"
            (click)="$event.stopPropagation()">
        {{ getLabel(item) }}
        <i class="fa fa-times ms-1" (click)="removeItem(item); $event.stopPropagation()"></i>
      </span>
    </div>

    <!-- Single text -->
    <div *ngIf="!multiple" class="text-truncate w-100 selectorini-value">
      <span *ngIf="hasSelection">{{ getLabel(value) }}</span>
    </div>

    <i class="fa fa-chevron-down ms-2 chevron-icon" [class.rotated]="isOpen"></i>
  </div>
  <label>{{ label }}</label>

  <!-- Menu (fixed positioning to escape overflow) -->
  <ul #menuEl class="dropdown-menu selectorini-menu show" [ngStyle]="menuStyle" *ngIf="isOpen">
    <!-- Search input -->
    <li *ngIf="searchable" class="selectorini-search-container" (click)="$event.stopPropagation()">
      <input
        #searchInput
        type="text"
        class="form-control form-control-sm selectorini-search"
        [(ngModel)]="searchBuffer"
        [placeholder]="'common.search' | translate"
        (keydown.escape)="isOpen = false"
        autocomplete="off"
      >
    </li>
    <li *ngIf="searchable && filteredOptions.length === 0" class="dropdown-item text-muted disabled">
      {{ 'common.noResults' | translate }}
    </li>
    <li *ngFor="let opt of filteredOptions"
        class="dropdown-item d-flex justify-content-between align-items-center"
        [class.active]="isSelected(opt)"
        (click)="selectItem(opt); $event.stopPropagation()">
      <span>{{ getLabel(opt) }}</span>
      <i *ngIf="isSelected(opt)" class="fa fa-check"></i>
    </li>
  </ul>
</div>

<!-- Non-floating variant (original) -->
<div *ngIf="!floating || !label" class="selectorini-wrapper" [class.disabled]="disabled" [class.dropup]="dropUp">
  <!-- Control -->
  <div class="selectorini-control d-flex align-items-center justify-content-between"
       (click)="toggleDropdown()">
    <!-- Multiple pills -->
    <div *ngIf="multiple" class="d-flex flex-wrap gap-2 w-100">
      <span *ngIf="!valueArray.length" class="text-muted">{{ placeholder }}</span>
      <span *ngFor="let item of valueArray" class="badge rounded-pill px-2 py-1"
            (click)="$event.stopPropagation()">
        {{ getLabel(item) }}
        <i class="fa fa-times ms-1" (click)="removeItem(item); $event.stopPropagation()"></i>
      </span>
    </div>

    <!-- Single text -->
    <div *ngIf="!multiple" class="text-truncate w-100">
      <span *ngIf="!hasSelection" class="text-muted">{{ placeholder }}</span>
      <span *ngIf="hasSelection">{{ getLabel(value) }}</span>
    </div>

    <i class="fa fa-chevron-down ms-2"></i>
  </div>

  <!-- Menu (fixed positioning to escape overflow) -->
  <ul #menuEl class="dropdown-menu selectorini-menu show" [ngStyle]="menuStyle" *ngIf="isOpen">
    <!-- Search input -->
    <li *ngIf="searchable" class="selectorini-search-container" (click)="$event.stopPropagation()">
      <input
        type="text"
        class="form-control form-control-sm selectorini-search"
        [(ngModel)]="searchBuffer"
        [placeholder]="'common.search' | translate"
        (keydown.escape)="isOpen = false"
        autocomplete="off"
      >
    </li>
    <li *ngIf="searchable && filteredOptions.length === 0" class="dropdown-item text-muted disabled">
      {{ 'common.noResults' | translate }}
    </li>
    <li *ngFor="let opt of filteredOptions"
        class="dropdown-item d-flex justify-content-between align-items-center"
        [class.active]="isSelected(opt)"
        (click)="selectItem(opt); $event.stopPropagation()">
      <span>{{ getLabel(opt) }}</span>
      <i *ngIf="isSelected(opt)" class="fa fa-check"></i>
    </li>
  </ul>
</div>
